import { CommonModule as NgCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DismissalNoteComponent } from './dismissal-note.component';

const CORE_MODULES = [
  NgCommonModule,
];

const COMPONENTS = [
  DismissalNoteComponent,
];

@NgModule({
  imports: CORE_MODULES,
  declarations: COMPONENTS,
  exports: COMPONENTS,
})

export class DismissalNoteModule { }
